import { isNullOrEmptyString } from "./index";

const countriesWhereToDisplayStateCode: Set<server.dto.Countries> = new Set(["unitedStates", "brazil"]);


export const getCityStateCountry = (address: server.dto.Address) => {
  const country = address.countryName;
  const displayState = countriesWhereToDisplayStateCode.has(address.country);

  if(displayState) {
    return [address.city, address.stateCode, country].filter(s => !isNullOrEmptyString(s)).join(", ");
  }

  return [address.city, country].filter(s => !isNullOrEmptyString(s)).join(", ");
}
